module PortalLibs.Client.Components.Multiline


open Browser.Types
open Fable.React
open Elmish
open Thoth.Elmish
open System
open PortalLibs.Client.Util
open Feliz
open Fable.Core.JsInterop
open Feliz.UseElmish

type private Model =
  { BoundValue: string
    IsLoading: bool
    //Input : string
    Debouncer: Debouncer.State }


type ReadWriteSettings =
  { ValueChanged: string -> unit
    Spellcheck: bool }

type Mode =
  | Readonly
  | ReadWrite of ReadWriteSettings

type private Msg =
  | Input of string
  | InputChanged of string
  | DebouncerSelfMsg of Debouncer.SelfMessage<Msg>

let private init value : Model * Cmd<Msg> =
  {
    //Input = value
    IsLoading = false
    BoundValue = value
    Debouncer = Debouncer.create ()
  //IconVisible = true
  },
  Cmd.none

let private update mode msg model =
  match msg with
  | DebouncerSelfMsg debouncerMsg ->
    let debouncerModel, debouncerCmd =
      Debouncer.update debouncerMsg model.Debouncer

    { model with Debouncer = debouncerModel }, debouncerCmd
  | Input s ->
    let debouncerModel, debouncerCmd =
      if s <> "" then
        model.Debouncer
        |> Debouncer.bounce (TimeSpan.FromSeconds 1.0) "MultilineChange" (InputChanged s)
      else
        Debouncer.create (), Cmd.none

    { model with
        BoundValue = s
        IsLoading = true
        Debouncer = debouncerModel },
    Cmd.batch [
      yield Cmd.map DebouncerSelfMsg debouncerCmd
      if s = "" then
        yield Cmd.ofMsg (InputChanged s)
    ]
  | InputChanged s ->
    { model with IsLoading = false },
    match mode with
    | Readonly -> Cmd.none
    | ReadWrite settings -> Cmd.ofSub (fun _ -> settings.ValueChanged s)

let private MultilineInnerComp =
  React.memo (
    "MultilineInnerComp",
    (fun (props: {| Mode: Mode
                    Key: string
                    BoundValue: string
                    Rows: int option
                    MaxRows: int option
                    Ref: IRefValue<HTMLElement option> option
                    Dispatch: Msg -> unit |}) ->
      let inputProps =
        createObj [
          yield
            "onChange"
            => (fun (e: Browser.Types.Event) -> Input(e.Value) |> props.Dispatch)
          match props.Ref with
          | Some r -> yield "ref" => r
          | None -> ()
          yield "defaultValue" => props.BoundValue
          //    "value" => txtValue
          //    "innerRef" => (fun e -> if e |> isNull |> not && !!e?value <> !!txtValue then e?value <- !!txtValue)
          yield "key" => props.Key
          yield
            "className"
            => match props.Mode with
               | Readonly -> "textarea disabledtextarea"
               | ReadWrite _ -> "textarea"
          yield
            "spellCheck"
            => match props.Mode with
               | Readonly -> false
               | ReadWrite settings -> settings.Spellcheck
          //match mode with
          //| Readonly -> yield "readonly" => "readonly"
          //| ReadWrite _ -> ()
          match props.Mode with
          | Readonly -> yield "disabled" => "disabled"
          | ReadWrite _ -> ()

          match props.Rows with
          | None -> ()
          | Some rows -> yield "rows" => rows

          match props.MaxRows with
          | None -> ()
          | Some rows -> yield "maxRows" => rows

          // todo: refactor to parameter props.MaxLength and fix all usages?
          // is this limit safe for all usages?
          yield "maxLength" => 1500

          yield
            "style"
            => match props.Mode with
               | Readonly ->
                 createObj [
                   "padding" => "calc(0.3em - 1px) 0 0 0"
                   "cursor" => "auto"
                 ]
               | ReadWrite _ ->
                 createObj [
                   "padding" => "calc(0.3em - 1px)"
                 ]
        ]

      ofImport "default" "react-autosize-textarea" inputProps []),
    (fun (props: {| Mode: Mode
                    Key: string
                    BoundValue: string
                    Rows: int option
                    MaxRows: int option
                    Ref: IRefValue<HTMLElement option> option
                    Dispatch: Msg -> unit |}) -> props.Key),
    areEqual = Helpers.equalsButFunctions
  )

[<ReactComponent>]
let Multiline
  (props: {| Mode: Mode
             Value: string
             Key: string
             Rows: int option
             MaxRows: int option
             Ref: IRefValue<HTMLElement option> option |})
  =
  let state, dispatch =
    React.useElmish (init props.Value, update props.Mode, [| box props.Value; box props.Mode |])

  MultilineInnerComp
    {| Mode = props.Mode
       Key = props.Key
       Rows = props.Rows
       MaxRows = props.MaxRows
       BoundValue = state.BoundValue
       Ref = props.Ref
       Dispatch = dispatch |}
